import React from 'react'
import { useTranslation } from 'react-i18next'
import { Menu, Text } from '@mantine/core'
import { Icon } from '@/components/Elements'
import { useAppConfirmModal } from '@/features/app/hooks'
import { ExtendedUserType } from '@/features/users/types'

interface IProps {
  data: ExtendedUserType
  onRestore?: (data: ExtendedUserType) => void
}

export const RestoreControl = ({ data, onRestore }: IProps) => {
  const { t } = useTranslation()

  const { open } = useAppConfirmModal({ onConfirm: () => onRestore?.(data) })

  return (
    <Menu.Item icon={<Icon name={'trash-restore'} />} onClick={() => open()}>
      <Text>{t('restore')}</Text>
    </Menu.Item>
  )
}
